import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AddTranslationDialogStateModel, AddTranslationDialogActionForm } from '../../../model';

@State<AddTranslationDialogStateModel>({
  name: 'addTranslationDialog',
  defaults: {
    actionForm: {
      model: undefined,
      dirty: false,
      status: '',
      errors: {},
    },
  },
})
@Injectable()
export class AddTranslationDialogState {
  @Selector()
  static addTranslationDialogActionForm(state: AddTranslationDialogStateModel): AddTranslationDialogActionForm {
    return state.actionForm.model;
  }
}
